import { FC, MutableRefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import { ConsultationFragment } from '@/shared/api/transcriptor/transcriptorApi';

import styles from '../TranscriptView.module.scss';

import { TranscriptChunkButton } from './TranscriptChunkButton';

type TranscriptFragmentProps = {
  audioRefs: MutableRefObject<Record<string, HTMLAudioElement | null>>;
  fragment: ConsultationFragment;
  index: number;
  onChunkClick: (fragmentId: string, start: number) => void;
};

export const TranscriptFragment: FC<TranscriptFragmentProps> = (props) => {
  const { audioRefs, fragment, index, onChunkClick } = props;
  const audioUrl = fragment.audio?.url ?? '';
  const chunks = fragment.transcript?.chunks ?? [];

  return (
    <section className={styles.fragment} data-component="transcript-fragment">
      <div className={styles.header}>
        <h3 className={styles.title}>
          <FormattedMessage
            id="encounters.details.audioTitle"
            defaultMessage="Audio {index}"
            values={{ index: index + 1 }}
          />
        </h3>
        {audioUrl && (
          <audio
            ref={(element) => {
              audioRefs.current[fragment.id] = element;
            }}
            controls
            preload="metadata"
            src={audioUrl}
            className={styles.player}
          />
        )}
      </div>

      {chunks.length > 0 && (
        <div className={styles.chunks}>
          {chunks.map((chunk, chunkIndex) => (
            <TranscriptChunkButton
              key={`${fragment.id}-${chunkIndex}`}
              chunk={chunk}
              fragmentId={fragment.id}
              index={chunkIndex}
              onClick={onChunkClick}
            />
          ))}
        </div>
      )}
    </section>
  );
};
